var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('h2',[_vm._v(_vm._s(_vm.heading))]),_c('div',{staticClass:"ml-auto d-flex align-end"},[_vm._t("tools")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }